// Libs
import { TFunction } from 'i18next';
import * as yup from 'yup';
import { ObjectSchema } from 'yup';
// Others
import { IFormAppointment } from '~/utils/interface/appointment';
import { EMPTY_STRING } from '~/utils/constants/common';

export const schema = (t: TFunction): ObjectSchema<IFormAppointment> => {
  return yup.object({
    title: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    type: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    status: yup.string().required(t('common_validate_field_required', { ns: 'common/base' })),
    endTime: yup
      .string()
      .trim()
      .optional()
      .test('is-after-start', t('common_validate_compare_time', { ns: 'common/base' }), function (value) {
        const { startTime } = this.parent;
        return !startTime || !value || value > startTime;
      }),
    date: yup.string().trim().optional(),
    startTime: yup.string().trim().optional(),
    clientId: yup.string().optional(),
    location: yup.string().trim().optional(),
    note: yup.string().trim().optional(),
  });
};

export const defaultValuesAppointmentForm: IFormAppointment = {
  clientId: EMPTY_STRING,
  title: EMPTY_STRING,
  type: EMPTY_STRING,
  date: EMPTY_STRING,
  startTime: EMPTY_STRING,
  endTime: EMPTY_STRING,
  location: EMPTY_STRING,
  note: EMPTY_STRING,
};
